import React from 'react'
import { Photo } from '../../models/media'
import { Checkbox } from 'primereact/checkbox'
import BadgeIcon from '../data/BadgeIcon'
import LuxButton from '../buttons/Button'
import './media.scss'
import { LuxLoadingCircle } from '../../Techedge-Wardrobe'

const PhotoCard = (props: {
    photo: Photo
    handleImageClick: (e: any) => void
    selectionActive?: boolean
    colWidth?: string | number
    photoActions?: {
        open: (photo: Photo) => void
        replace: (photo: Photo) => void
        delete: (photo: Photo) => void
    }
    onLoad?: () => void
    isLastItem?: boolean
}) => {
    const {
        photo,
        handleImageClick,
        selectionActive,
        colWidth,
        photoActions,
        onLoad,
        isLastItem,
    } = props

    const footer = (
        <span className="p-my-0 p-mx-2 img-label">
            {photo.icon && (
                <BadgeIcon
                    color={photo.icon.color}
                    iconName={photo.icon.name}
                    tooltip={photo.icon.tooltip}
                />
            )}
            {((photo.store && photo.store.store_id) || photo.store_id) && (
                <>
                    <span className="mr-1 p-0 img-label">
                        <strong>
                            {'#' +
                                ((photo.store && photo.store.store_id) ||
                                    photo.store_id)}
                        </strong>
                    </span>
                    {photo.name && <span className="mr-1 p-0">-</span>}
                </>
            )}
            {photo.name && <span className="img-name">{photo.name}</span>}
            {photo.description && (
                <span className="img-description">{photo.description}</span>
            )}
        </span>
    )

    return (
        <div
            className={`gallery-image p-col-12 p-sm-6 p-md-4 p-lg-${
                colWidth ? colWidth : '3'
            }`}>
            <button
                onClick={() => handleImageClick(photo)}
                className="lux-img-container p-mb-2">
                <div
                    style={{
                        backgroundImage: `url(${photo.thumbnail_fullpath})`,
                    }}
                    className={`lux-img ${
                        selectionActive ? 'selection-active' : ''
                    } ${selectionActive && photo.selected ? 'opacity' : ''}`}>
                    {isLastItem && (
                        <img
                            onLoad={onLoad}
                            style={{ display: 'none' }}
                            src={photo.thumbnail_fullpath}
                        />
                    )}
                </div>
                {selectionActive && (
                    <Checkbox
                        checked={photo.selected ? true : false}
                        className="photo-card-checkbox"
                    />
                )}
            </button>
            {footer}
            {photoActions && (
                <div className="lux-image-actions">
                    {photoActions.open ? (
                        <LuxButton
                            text={''}
                            icon={'search'}
                            tooltip={'Preview'}
                            variant={['outlined']}
                            tooltipPosition={'bottom'}
                            onClick={() => photoActions.open(photo)}
                        />
                    ) : (
                        <></>
                    )}
                    {photoActions.replace ? (
                        <LuxButton
                            text={''}
                            icon={'replay'}
                            tooltip={'Replace'}
                            variant={['outlined']}
                            tooltipPosition={'bottom'}
                            onClick={() => photoActions.replace(photo)}
                        />
                    ) : (
                        <></>
                    )}
                    {photoActions.delete ? (
                        <LuxButton
                            text={''}
                            icon={'times'}
                            tooltip={'Delete'}
                            variant={['outlined']}
                            tooltipPosition={'bottom'}
                            onClick={() => photoActions.delete(photo)}
                        />
                    ) : (
                        <></>
                    )}
                </div>
            )}
        </div>
    )
}

export default PhotoCard
